import React from 'react'
import { type LucideProps } from 'lucide-react'

const OpenSource: React.FC<LucideProps> = (props: LucideProps) => (
<svg
  width={22}
  height={20}
  viewBox="0 0 22 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M20.5921 11.7018C20.3277 11.7018 20.1129 11.9158 20.1129 12.181V17.3739C20.1129 17.8428 19.7311 18.2245 19.2623 18.2245L2.75382 18.2253C2.28499 18.2253 1.90323 17.8436 1.90323 17.3747V12.1811C1.90323 11.9159 1.6884 11.7019 1.42403 11.7019C1.15966 11.7019 0.944824 11.9159 0.944824 12.1811V17.374C0.944824 18.3716 1.75628 19.183 2.75379 19.183H19.2623C20.2598 19.183 21.0712 18.3716 21.0712 17.374V12.1811C21.0712 11.9167 20.8564 11.7019 20.592 11.7019L20.5921 11.7018Z"
    fill="#949494"
  />
  <path
    d="M11.0079 0.411883C10.7435 0.411883 10.5287 0.625919 10.5287 0.891087V11.7266L7.26618 8.46481C7.07928 8.27792 6.77579 8.27792 6.5889 8.46481C6.40201 8.65171 6.40201 8.95519 6.5889 9.14209L10.6692 13.2218C10.714 13.2665 10.7667 13.3016 10.8266 13.3264C10.829 13.3272 10.8314 13.328 10.8338 13.3288C10.8881 13.3503 10.9472 13.3631 11.0087 13.3631C11.0702 13.3631 11.1293 13.3503 11.1836 13.3288C11.186 13.328 11.1884 13.3272 11.1908 13.3264C11.2499 13.3024 11.3034 13.2665 11.3481 13.2218L15.4285 9.14209C15.6154 8.95519 15.6154 8.65171 15.4285 8.46481C15.2416 8.27792 14.9381 8.27792 14.7512 8.46481L11.487 11.7273V0.890917C11.487 0.626549 11.2722 0.411713 11.0078 0.411713L11.0079 0.411883Z"
    fill="#949494"
  />
</svg>


)

export default OpenSource
